import { Outlet } from 'react-router-dom';

import { RequireAdmin } from '../../components/routes/require-admin';

export const CelebrationsRoot = () => {
	return (
		<RequireAdmin require="awards">
			<Outlet />
		</RequireAdmin>
	);
};
